export default "__VITE_ASSET__B9953$oE__"